var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFolderOpen = function SvgFolderOpen(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 44.26 30.96"
  }, props), _path || (_path = React.createElement("path", {
    fill: "currentColor",
    d: "M3.44 20H0V0h17.71l5.1 5.09h14.8v3.44H21.38l-5.09-5.09H3.44zm40.82-7H10.34L4.13 31h33.92zm-31.47 3.42h26.64l-3.83 11.1H9z",
    "data-name": "Layer 2"
  })));
};
export default __webpack_public_path__ + "75c96ce6c326f8ab0a9a47f24d8ad67f.svg";
export { SvgFolderOpen as ReactComponent };